// App name comes from the repo-level app.config.js (injected by vue.config.js).
export const APP_NAME = process.env.VUE_APP_NAME
